// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","social":"Footer_social__1qlfP","imgSocial":"Footer_imgSocial__2zP1c","copy":"Footer_copy__LYJo6"};